"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "mb-2 grid grid-cols-2" };
const _hoisted_3 = { class: "mt-1 flex space-x-4" };
const _hoisted_4 = { class: "block font-bold" };
const _hoisted_5 = ["value"];
const _hoisted_6 = {
    key: 0,
    class: "text-shadow-black text-white absolute text-center font-bold w-full"
};
const _hoisted_7 = ["src", "alt", "title"];
const _hoisted_8 = {
    key: 0,
    class: "mt-1"
};
const _hoisted_9 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_10 = { key: 1 };
const _hoisted_11 = {
    for: "search",
    class: "px-4 py-2 inline-block h-full leading-none bg-gray-darker text-white"
};
const _hoisted_12 = {
    class: "inline-block",
    value: "key"
};
const _hoisted_13 = {
    class: "inline-block",
    value: "context"
};
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "pager mt-2 flex justify-center space-x-4" };
const _hoisted_16 = { class: "current font-bold border px-2 py-1 flex items-center" };
const _hoisted_17 = { class: "ml-auto font-bold border px-2 py-1 flex items-center" };
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const TranslationFilterButton_vue_1 = __importDefault(require("./TranslationFilterButton.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const _locales_1 = __importDefault(require("../../common/i18n/_locales"));
const Filters_1 = __importDefault(require("../../models/Filters"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminTranslations',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const state = (0, vue_3.reactive)({
            languages: _locales_1.default,
            workingLanguages: [],
            translations: [],
            filters: new Filters_1.default(),
            totalItems: 0,
            totalPages: 0,
        });
        const loadByFilters = async () => {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "admin_translations_api", query: state.filters.createQuery() }).href);
                state.translations = response["hydra:member"];
                state.totalItems = response["hydra:totalItems"];
                state.totalPages = Math.ceil(state.totalItems / state.filters.itemsPerPage);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const updateTranslationAPI = async (item) => {
            try {
                const url = router.resolve({ name: "admin_translations_api" }).href + "/" + item.id;
                return await (0, fetch_1.default)(url, { method: "PATCH", body: JSON.stringify(item) });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const writeOutTranslationsAPI = async () => {
            try {
                const url = router.resolve({ name: "admin_translations_api_write_out_translations" }).href;
                return await (0, fetch_1.default)(url, { method: "POST" });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const fields = (0, vue_3.computed)(() => {
            var _a, _b, _c;
            const allFields = [
                { key: "id", label: (_a = (0, i18n_1.trans)("id", "ID", "translations")) !== null && _a !== void 0 ? _a : "ID", value: "id" },
                {
                    key: "context",
                    label: (_b = (0, i18n_1.trans)("context", "Context", "translations")) !== null && _b !== void 0 ? _b : "Context",
                    value: "context",
                },
                {
                    key: "key",
                    label: (_c = (0, i18n_1.trans)("key", "Key", "translations")) !== null && _c !== void 0 ? _c : "Key",
                    value: "key",
                },
                { key: "en", label: "en", value: "en" },
                { key: "hu", label: "hu", value: "hu" },
                { key: "ro", label: "ro", value: "ro" },
                { key: "sr", label: "sr", value: "sr" },
            ];
            allFields.forEach((column) => {
                if (!["key", "context"].includes(column.key)) {
                    column.visible = state.filters.workingLanguages.includes(column.key);
                }
            });
            return allFields;
        });
        const viewPage = async (page) => {
            if (page < 1)
                page = 1;
            state.filters.page = page;
            await loadByFilters();
        };
        const validatePage = () => {
            let page = Number(state.filters.page.toString().replace(/[^0-9]/g, ""));
            if (page > state.totalPages)
                page = state.totalPages;
            state.filters.page = page;
        };
        const validateItemsPerPage = () => {
            state.filters.itemsPerPage = Number(state.filters.itemsPerPage.toString().replace(/[^0-9]/g, ""));
            state.filters.page = 1;
        };
        const updateTranslation = async (translation, field, event) => {
            var _a, _b;
            if (event.target instanceof HTMLInputElement) {
                const element = event.target;
                if (element.value === "") {
                    toastStore.addErrorToast((_a = (0, i18n_1.trans)("translation_cant_be_empty", "Translation cant be empty", "translations")) !== null && _a !== void 0 ? _a : "Translation cant be empty!");
                    return;
                }
                element.style.boxShadow = "inset 0px 0px 5px orange";
                element.disabled = true;
                const item = { id: translation.id };
                item[field] = element.value;
                try {
                    await updateTranslationAPI(item);
                    element.style.boxShadow = "inset 0px 0px 5px green";
                    setTimeout(() => {
                        element.style.boxShadow = "none";
                        element.disabled = false;
                    }, 3000);
                    toastStore.addToast({
                        title: (_b = (0, i18n_1.trans)("text_saved", `Text saved: "{key}"`, "translations", { key: element.value })) !== null && _b !== void 0 ? _b : `Text saved:  "${element.value}"`,
                        type: "success",
                        showIcon: false,
                        showClose: false,
                        timer: 3,
                    });
                }
                catch (error) {
                    element.style.boxShadow = "inset 0px 0px 5px red";
                    element.disabled = false;
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const order = async (field) => {
            if (field === state.filters.orderBy) {
                state.filters.orderDirection = state.filters.orderDirection === "asc" ? "desc" : "asc";
            }
            else {
                state.filters.orderBy = field;
                state.filters.orderDirection = "asc";
            }
            await loadByFilters();
        };
        const workingLanguageSelected = async () => {
            if (state.filters.workingLanguages.length) {
                await loadByFilters();
            }
        };
        const search = async () => {
            await loadByFilters();
        };
        const writeOutTranslations = async (event) => {
            var _a;
            if (event.target instanceof HTMLButtonElement) {
                const button = event.target;
                button.disabled = true;
                try {
                    await writeOutTranslationsAPI();
                    toastStore.addToast({
                        title: (_a = (0, i18n_1.trans)("export_complete", "Export complete!", "translations")) !== null && _a !== void 0 ? _a : "Export complete!",
                        type: "success",
                        icon: "marso-icon-right",
                        showClose: false,
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
                finally {
                    button.disabled = false;
                }
            }
        };
        const reloadPage = async () => {
            await loadByFilters();
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("select_languages", "Select languages", "translations")) + ":", 1),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(state.languages, (lang) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                key: lang.locale,
                                class: "block relative w-6 cursor-pointer"
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.filters.workingLanguages) = $event)),
                                    type: "checkbox",
                                    name: "workingLanguages[]",
                                    value: lang.locale,
                                    class: "hidden",
                                    onChange: workingLanguageSelected
                                }, null, 40, _hoisted_5), [
                                    [vue_2.vModelCheckbox, state.filters.workingLanguages]
                                ]),
                                (state.filters.workingLanguages.includes(lang.locale))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, (0, vue_2.toDisplayString)(lang.locale), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("img", {
                                    src: 'images/flags/' + lang.flag,
                                    alt: 'flag ' + lang.title,
                                    title: lang.title
                                }, null, 8, _hoisted_7)
                            ]));
                        }), 128))
                    ]),
                    (state.filters.workingLanguages.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "mx-auto btn btn-rounded btn-primary btn-danger",
                                type: "button",
                                onClick: _cache[1] || (_cache[1] = ($event) => (writeOutTranslations($event)))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("write_out_current_translations", "Write out current translations", "translations")), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (!state.filters.workingLanguages.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("flag_helper_text", "Please select first, which languages you want to translate or watch.", "translations")), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                (state.filters.workingLanguages.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            items: state.translations,
                            fields: (0, vue_2.unref)(fields),
                            condensed: ""
                        }, {
                            header: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("label", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("search", "Search", "translations")), 1),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((state.filters.searchParameter) = $event)),
                                    class: "inline-block h-full bg-light-gray text-black p-1 leading-none",
                                    onChange: search
                                }, [
                                    (0, vue_2.createElementVNode)("option", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("key", "Key", "translations")), 1),
                                    (0, vue_2.createElementVNode)("option", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("context", "Context", "translations")), 1),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(state.filters.workingLanguages, (lang) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: lang,
                                            class: "inline-block",
                                            value: lang
                                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(lang, lang, "translations")), 9, _hoisted_14));
                                    }), 128))
                                ], 544), [
                                    [vue_2.vModelSelect, state.filters.searchParameter]
                                ]),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    id: "search",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((state.filters.searchString) = $event)),
                                    type: "text",
                                    class: "inline-block h-full p-1 text-black leading-none",
                                    onChange: search
                                }, null, 544), [
                                    [vue_2.vModelText, state.filters.searchString]
                                ])
                            ]),
                            "head-context": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('context', 'Context', 'translations'),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (order('context')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-key": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('key', 'Key', 'translations'),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (order('key')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-hu": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('hu', 'HU', 'translations'),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (order('hu')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-en": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('en', 'EN', 'translations'),
                                    onClick: _cache[7] || (_cache[7] = ($event) => (order('en')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-de": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('de', 'DE', 'translations'),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (order('de')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-ro": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('ro', 'RO', 'translations'),
                                    onClick: _cache[9] || (_cache[9] = ($event) => (order('ro')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-fr": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('fr', 'FR', 'translations'),
                                    onClick: _cache[10] || (_cache[10] = ($event) => (order('fr')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-sk": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('sk', 'SK', 'translations'),
                                    onClick: _cache[11] || (_cache[11] = ($event) => (order('sk')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-sr": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('sr', 'SR', 'translations'),
                                    onClick: _cache[12] || (_cache[12] = ($event) => (order('sr')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-cs": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('cs', 'CS', 'translations'),
                                    onClick: _cache[13] || (_cache[13] = ($event) => (order('cs')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "head-pl": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(TranslationFilterButton_vue_1.default, {
                                    filters: state.filters,
                                    label: (0, vue_2.unref)(i18n_1.trans)('pl', 'PL', 'translations'),
                                    onClick: _cache[14] || (_cache[14] = ($event) => (order('pl')))
                                }, null, 8, ["filters", "label"])
                            ]),
                            "cell-hu": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.hu,
                                    "onUpdate:modelValue": ($event) => ((item.hu) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'hu', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-en": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.en,
                                    "onUpdate:modelValue": ($event) => ((item.en) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'en', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-ro": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.ro,
                                    "onUpdate:modelValue": ($event) => ((item.ro) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'ro', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            "cell-sr": (0, vue_2.withCtx)(({ item: item }) => [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    modelValue: item.sr,
                                    "onUpdate:modelValue": ($event) => ((item.sr) = $event),
                                    border: "",
                                    onChange: ($event) => (updateTranslation(item, 'sr', $event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            footer: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary",
                                        type: "button",
                                        onClick: _cache[15] || (_cache[15] = ($event) => (viewPage(state.filters.page - 1)))
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("previous", "Previous", "translations")), 1),
                                    (0, vue_2.createElementVNode)("label", _hoisted_16, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("page", "Page", "translations")) + ": ", 1),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((state.filters.page) = $event)),
                                            class: "w-10 text-center",
                                            type: "text",
                                            onKeyup: [
                                                _cache[17] || (_cache[17] = ($event) => (validatePage())),
                                                _cache[18] || (_cache[18] = (0, vue_2.withKeys)(($event) => (reloadPage()), ["enter"]))
                                            ],
                                            onBlur: _cache[19] || (_cache[19] = ($event) => (reloadPage()))
                                        }, null, 544), [
                                            [vue_2.vModelText, state.filters.page]
                                        ]),
                                        (0, vue_2.createTextVNode)(" / " + (0, vue_2.toDisplayString)(state.totalPages), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary",
                                        type: "button",
                                        onClick: _cache[20] || (_cache[20] = ($event) => (viewPage(state.filters.page + 1)))
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("next", "Next", "translations")), 1),
                                    (0, vue_2.createElementVNode)("label", _hoisted_17, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("items_per_page", "Items per page", "translations")) + ": ", 1),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((state.filters.itemsPerPage) = $event)),
                                            class: "text-center w-10",
                                            type: "text",
                                            onKeyup: [
                                                _cache[22] || (_cache[22] = ($event) => (validateItemsPerPage())),
                                                _cache[23] || (_cache[23] = (0, vue_2.withKeys)(($event) => (reloadPage()), ["enter"]))
                                            ],
                                            onBlur: _cache[24] || (_cache[24] = ($event) => (reloadPage()))
                                        }, null, 544), [
                                            [vue_2.vModelText, state.filters.itemsPerPage]
                                        ]),
                                        (0, vue_2.createTextVNode)(" / " + (0, vue_2.toDisplayString)(state.totalItems), 1)
                                    ])
                                ])
                            ]),
                            _: 1
                        }, 8, ["items", "fields"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
